<template>

</template>
<script>
  import {getService} from "../../services";

  export default {
    name: 'Logout',
    mounted: function () {
      this.logout()
    },
    methods: {
        logout() {
            getService.logout()
                .then(data => {
                    localStorage.clear()
                    window.location.replace("https://isx.nusa.net.id/logout");
                })
        }
    }

  }
</script>
